export const parseUserId = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || !Number.isInteger(parsed) || parsed <= 0) {
    return null;
  }
  return parsed;
};

export const getStoredUserId = () => parseUserId(localStorage.getItem("userId"));

export const persistSession = ({ accessToken, userId, roleId }) => {
  const parsedUserId = parseUserId(userId);
  const parsedRoleId = parseUserId(roleId);

  if (!accessToken || parsedUserId === null) {
    console.warn("Refusing to persist session with invalid userId or token", {
      hasToken: Boolean(accessToken),
      userId,
    });
    return false;
  }

  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("userId", String(parsedUserId));
  if (parsedRoleId !== null) {
    localStorage.setItem("RoleId", String(parsedRoleId));
  }
  return true;
};
